import './style.scss';

export default function SocialIcons() {
    return (
        <div className="SocialIcons">
            <a
                href="https://www.facebook.com/neodvisniobalniradio"
                target="_blank"
                rel="noreferrer"
            >
                <img src="/facebook.svg" alt="facebook" className="social facebook" />
            </a>
            <a
                href="https://www.instagram.com/neodvisni.obalni.radio"
                target="_blank"
                rel="noreferrer"
            >
                <img src="/instagram.svg" className="social instagram" />
            </a>
            <a href="mailto:radimradio@gmail.com" target="_blank" rel="noreferrer">
                <img src="/mail.svg" alt="email" className="social mail" />
            </a>
        </div>
    );
}
